import { ae as serverGet, p as processBody, af as shippingRatesSchema, ag as promotions, ah as promotionsSchema, v as voBanners, b as voBannersSchema, a3 as createStrictSchema, u as userAdsSchema, ai as singleAdSchema, s as searchSchema, g as gallerizedSearchSchema, i as filterValuesSchema, aj as loggedUser, ak as loggedUserSchema, al as transaction, am as transactionSchema, an as transactions, ao as transactionsSchema, m as prices, n as pricesSchema, ap as userTransaction, aq as userTransactionSchema, ar as transactionP2PStates, as as transactionP2PStatesSchema, A as userAdInfo, B as userAdInfoSchema, at as shop, au as shopSchema, O as shops, P as shopsSchema, D as conversationID, E as conversationIDSchema, T as voGroups, U as voGroupsSchema, V as publicationFee, av as poFees, aw as feesSchema, ax as poFee, ay as poFeeSchema, az as serverPut, r as returnStatus, aA as adOwnerVerificationSchema, _ as savedSearchesSchema, aB as users, aC as usersSchema, aD as changeEmailIsEligible, aE as changeEmailIsEligibleSchema, aF as userSubscriptions, aG as userSubscriptionsSchema, aH as wallet, aI as walletTypeSchema, aJ as fullPayoutUser, aK as fullPayoutUserSchema, aL as hyperwalletAuthToken, aM as tokenSchema, aN as payment, aO as paymentSchema, aP as serverPost, aQ as purchasedPoOrder, aR as purchasedPoOrderSchema, aS as plutusPurchaseToken, aT as plutusPurchaseTokenSchema, a9 as userProfileInfo, aa as userProfileInfoSchema, aU as shopGoogleReviews, aV as shopGoogleReviewsSchema, ad as poCartRedirect } from './zod-BK1RGncv.js';
export { aX as extractSbtAppHeaders, aW as extractSbtHeaders, aY as requestIDHeaderName } from './zod-BK1RGncv.js';
import { j as shippingRates, u as userAds, k as adItem, s as searchResult, f as filterValues, l as adOwnerVerification, h as savedSearches } from './zod-DfBqeaiX.js';
import { z } from 'zod';
import { HTTPStatusCode } from './types.js';
import { morphism } from 'morphism';
import 'zod-validation-error';

const getRates = (origin, urn, sbtHeaders) => serverGet({
    url: `${origin}/v1/shipping/rates?urn=${urn}`,
    sbtHeaders,
}).then(processBody(shippingRatesSchema, shippingRates));

const getPromoInfo = (origin, sbtHeaders, timeout) => serverGet({
    queryParams: { active: true },
    url: `${origin}/v1/promotions`,
    sbtHeaders,
    timeoutMs: timeout,
}).then(processBody(promotionsSchema, promotions));
const getActiveVoBanners = (origin, entry_point, page, sbtHeaders, categories = []) => serverGet({
    url: `${origin}/v1/vouchers/banners`,
    sbtHeaders,
    queryParams: { entry_point, page, categories: categories.join(',') },
}).then(processBody(voBannersSchema, voBanners));

const sellerCapabilitiesSchema = createStrictSchema({
    multigestionaleRolloutComplete: 'pro_platform_rollout',
});

const sellerCapabilities = z.object({
    multigestionaleRolloutComplete: z.boolean(),
});

const getSellerCapabilities = (origin, userID, sbtHeaders) => serverGet({
    url: `${origin}/v1/users/${userID}/capabilities`,
    sbtHeaders,
}).then(processBody(sellerCapabilitiesSchema, sellerCapabilities));

const getUserAds = (origin, userID, sbtHeaders, params, logger, isProd = false) => serverGet({
    url: `${origin}/v1/manage/users/${userID}/items`,
    queryParams: params,
    sbtHeaders,
    logger,
}).then(processBody(userAdsSchema, isProd ? null : userAds));

const getSingleAd = (origin, listID, sbtHeaders, isProd = false) => serverGet({
    url: `${origin}/v1/search/items`,
    queryParams: {
        urn: `list:${listID}`,
    },
    sbtHeaders,
}).then(processBody(singleAdSchema, isProd ? null : adItem));
const searchItems = (origin, params, sbtHeaders, isProd = false) => serverGet({
    url: `${origin}/v1/search/items`,
    queryParams: params,
    sbtHeaders,
}).then(processBody(searchSchema, isProd ? null : searchResult));
const searchGallerized = (origin, params, sbtHeaders, isProd = false) => serverGet({
    url: `${origin}/v1/search/items/gallerized`,
    queryParams: {
        ...params,
        lim: params.lim ?? 3,
    },
    sbtHeaders,
}).then(processBody(gallerizedSearchSchema, isProd ? null : searchResult));
const searchGeoboosted = (origin, params, sbtHeaders, isProd = false) => serverGet({
    url: `${origin}/v1/search/items/geoboosted`,
    queryParams: {
        ...params,
        lim: params.lim ?? 5,
    },
    sbtHeaders,
}).then(processBody(searchSchema, isProd ? null : searchResult));
const getFilterValues = (origin, sbtHeaders, uri, category) => {
    if (!uri.startsWith('/v1/values')) {
        return Promise.reject(new Error('Missing or invalid URI parameter'));
    }
    return serverGet({
        url: `${origin}${uri}`,
        queryParams: {
            category,
        },
        sbtHeaders,
    }).then(processBody(filterValuesSchema, filterValues));
};

const getLoggedUser = (origin, sbtHeaders) => serverGet({
    url: `${origin}/v1/access/logged`,
    sbtHeaders,
}).then(processBody(loggedUserSchema, loggedUser));

const getTransaction = (origin, transactionType, transactionID, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/transactions/${transactionType}/instances/${transactionID}`,
    sbtHeaders,
}).then(processBody(transactionSchema, transaction));
const getTransactions = (origin, role, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/transactions?role=${role}`,
    sbtHeaders,
}).then(processBody(transactionsSchema, transactions));
const getPrices = (origin, transactionType, transactionID, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/transactions/${transactionType}/instances/${transactionID}/prices`,
    sbtHeaders,
}).then(processBody(pricesSchema, prices));
const getPricesPreview = (origin, transactionType, transactionID, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/transactions/${transactionType}/instances/${transactionID}/prices/preview`,
    sbtHeaders,
}).then(processBody(pricesSchema, prices));
const getTransactionRates = (origin, transactionType, transactionID, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/transactions/${transactionType}/instances/${transactionID}/rates`,
    sbtHeaders,
}).then(processBody(shippingRatesSchema, shippingRates));
const getUserTransactions = (origin, email, sbtHeaders) => serverGet({
    url: `${origin}/v1/private/p2p/transactions?email=${email}`,
    sbtHeaders,
}).then(processBody(userTransactionSchema, userTransaction));
const getTransactionStates = (origin, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/states`,
    sbtHeaders,
}).then(processBody(transactionP2PStatesSchema, transactionP2PStates));

const getUserAdInfo = (origin, userId, sbtHeaders, logger) => serverGet({
    url: `${origin}/v1/accounts/search/${userId}/info`,
    sbtHeaders,
    logger,
}).then(processBody(userAdInfoSchema, userAdInfo));

const getShop = (origin, shopID, sbtHeaders) => serverGet({
    url: `${origin}/v1/shops-q/${shopID}`,
    sbtHeaders,
}).then(processBody(shopSchema, shop));
const searchShops = (origin, params, sbtHeaders) => serverGet({
    url: `${origin}/v1/shops-q`,
    queryParams: {
        ...params,
    },
    sbtHeaders,
}).then(processBody(shopsSchema, shops));
const getShopByUserId = (origin, userID, sbtHeaders) => serverGet({
    url: `${origin}/v1/shops-c/users/${userID}`,
    sbtHeaders,
}).then(processBody(shopSchema, shop));

const getConversationID = (origin, userID, partnerID, itemID, sbtHeaders) => serverGet({
    url: `${origin}/v1/mcproxy/api/hal/${userID}/conversations?partnerId=${partnerID}&itemId=${itemID}&itemType=ad`,
    sbtHeaders,
}).then(processBody(conversationIDSchema, conversationID));

const getVisibilityOptions = (origin, adID, categoryID, flowInfo, sbtHeaders, uiVariant, logger) => serverGet({
    url: `${origin}/v1/payments/paid_options`,
    queryParams: {
        ad_id: adID,
        category: categoryID,
        variant_id: uiVariant,
        entry_point: flowInfo.entrypoint,
        action_id: flowInfo.adVersion,
    },
    sbtHeaders,
    acceptedErrorStatuses: [HTTPStatusCode.Conflict],
    logger,
}).then(processBody(voGroupsSchema, voGroups));
const getPublicationFee = (origin, categoryID, sbtHeaders, logger) => serverGet({
    url: `${origin}/v1/payments/categories/${categoryID}/publication_fee`,
    sbtHeaders,
    acceptedErrorStatuses: [HTTPStatusCode.NotFound],
    logger,
}).then(processBody(null, publicationFee));
const getFees = (origin, categoryID, sbtHeaders, flowInfo, logger) => serverGet({
    url: `${origin}/v1/payments/categories/${categoryID}/fees`,
    queryParams: {
        entry_point: flowInfo?.entrypoint,
        ad_id: flowInfo?.adID,
    },
    sbtHeaders,
    logger,
}).then(processBody(feesSchema, poFees));
const getFee = (origin, feeName, categoryID, sbtHeaders, flowInfo, logger) => serverGet({
    url: `${origin}/v1/payments/categories/${categoryID}/fees/${feeName}`,
    queryParams: {
        entry_point: flowInfo?.entrypoint,
        ad_id: flowInfo?.adID,
    },
    sbtHeaders,
    logger,
}).then(processBody(poFeeSchema, poFee));

const verifyAdOwner = (origin, adID, userID, sbtHeaders, logger) => serverGet({
    url: `${origin}/v1/owner/user/${userID}/item/${adID}/verify`,
    sbtHeaders,
    logger,
}).then(processBody(adOwnerVerificationSchema, adOwnerVerification));
const prolongAd = (origin, adID, userID, source, sbtHeaders) => serverPut({
    url: `${origin}/v1/prolong/user/${userID}/item/${adID}?source=${source}`,
    sbtHeaders,
}).then(returnStatus);

const getUserSavedSearch = (origin, userID, sbtHeaders, logger) => serverGet({
    url: `${origin}/v1/searches-q/users/${userID}/searches`,
    sbtHeaders,
    logger,
}).then(processBody(savedSearchesSchema, savedSearches));

const favStatisticsSchema = createStrictSchema({
    counter: {
        path: 'counter',
        fn: (propertyValue) => ({
            value: Number(propertyValue.key),
        }),
    },
});

const favCounter = z.object({
    value: z.number(),
});
const favStatistics = z.object({
    counter: favCounter,
});

const getFavAdStatistics = (origin, adId, sbtHeaders, timeout) => serverGet({
    url: `${origin}/v1/favorites/ads/${adId}/stats`,
    sbtHeaders,
    timeoutMs: timeout,
}).then(processBody(favStatisticsSchema, favStatistics));

const getUsers = (origin, filterType, filterValue, sbtHeaders) => serverGet({
    url: `${origin}/v1/private/users?filter_type=${filterType}&filter_value=${filterValue}`,
    sbtHeaders,
}).then(processBody(usersSchema, users));
const changeEmailEligibility = (origin, userId, sbtHeaders) => {
    return serverGet({
        url: `${origin}/v1/users/${userId}/change-email/eligibility`,
        sbtHeaders,
    }).then(processBody(changeEmailIsEligibleSchema, changeEmailIsEligible));
};

const getUserSubscriptions = (origin, userID, params, sbtHeaders) => serverGet({
    url: `${origin}/v1/subscriptions/users/${userID}`,
    queryParams: params,
    sbtHeaders,
}).then(processBody(userSubscriptionsSchema, userSubscriptions));

const getWalletType = (origin, userID, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/payments/users/${userID}/wallet-type`,
    sbtHeaders,
}).then(processBody(walletTypeSchema, wallet));
const getPayoutUser = (origin, userID, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/payments/users/${userID}`,
    sbtHeaders,
    acceptedErrorStatuses: [HTTPStatusCode.NotFound],
}).then(processBody(fullPayoutUserSchema, fullPayoutUser));
const getHyperwalletAuthToken = (origin, sbtHeaders) => serverGet({
    url: `${origin}/v1/p2p/payments/hyperwallet/token`,
    sbtHeaders,
}).then(processBody(tokenSchema, hyperwalletAuthToken));
const getPayments = (origin, transactionType, transactionID, sbtHeaders) => serverGet({
    url: `${origin}/v1/private/p2p/payments?purchase_type=${transactionType}&purchase_id=${transactionID}`,
    sbtHeaders,
}).then(processBody(paymentSchema, payment));

const generateCarInfoSchema = (source) => {
    const { features, hierarchy } = source;
    const normalizeValues = (values) => (values.length > 0 ? values.map((v) => v.value).join(',') : '—');
    return hierarchy
        .map((h) => {
        const transformedFeatures = h.features
            .map((hf) => {
            const feature = features.find((f) => f.uri === hf.uri);
            if (!feature)
                return null;
            return {
                label: feature.label,
                value: normalizeValues(feature.values),
                uri: feature.uri,
            };
        })
            .filter((f) => f !== null);
        return { title: h.value, features: transformedFeatures };
    })
        .filter((item) => item.features.length > 0);
};
const carInfoSchema = (json) => {
    const body = json;
    return generateCarInfoSchema(body);
};

// Original response
const rawCarInfoFeaturesValue = z.object({
    key: z.string(),
    value: z.string(),
    weight: z.number(),
});
const rawCarInfoFeatures = z.object({
    type: z.string(),
    uri: z.string(),
    label: z.string(),
    values: z.array(rawCarInfoFeaturesValue),
});
const rawCarInfoHierarchyFeature = z.object({
    uri: z.string(),
});
const rawCarInfoHierarchy = z.object({
    key: z.string(),
    value: z.string(),
    features: z.array(rawCarInfoHierarchyFeature),
});
z.object({
    features: z.array(rawCarInfoFeatures),
    hierarchy: z.array(rawCarInfoHierarchy),
});
// Desired output schema
const carInfoFeature = z.object({
    label: z.string(),
    value: z.string(),
    uri: z.string(),
});
const carInfo = z.array(z.object({
    title: z.string(),
    features: z.array(carInfoFeature),
}));

const getLatestVersion = (origin, versionCode, year, month, sbtHeaders) => serverGet({
    url: `${origin}/v1/cars/latest-version`,
    queryParams: {
        version_code: versionCode,
        reg_year: year,
        reg_month: month,
    },
    sbtHeaders,
}).then(processBody(carInfoSchema, carInfo));
const getSingleVersion = (origin, feature, sbtHeaders) => {
    const { brand, model, version } = feature;
    const safeBrand = encodeURIComponent(brand);
    const safeModel = encodeURIComponent(model);
    const safeVersion = encodeURIComponent(version);
    return serverGet({
        url: `${origin}/v1/brands/${safeBrand}/models/${safeModel}/versions/${safeVersion}`,
        sbtHeaders,
    }).then(processBody(carInfoSchema, carInfo));
};

const faqItem = z.object({
    question: z.string(),
    answer: z.string(),
});
const faqItems = z.array(faqItem);
const faq = z.object({
    intro: z.string(),
    faq: faqItems,
});

const getFaq = (origin, queryString, sbtHeaders) => serverGet({
    url: `${origin}/v1/faq/content?${queryString}`,
    sbtHeaders,
}).then(processBody(null, faq));

const billingCompanyInfo = z.object({
    companyName: z.string(),
    vat: z.string(),
    taxCode: z.string(),
    companyRef: z.string().optional(),
    pec: z.string().optional(),
    sdi: z.string().optional(),
});
const billingPrivateInfo = z.object({
    invoice: z.boolean(),
    name: z.string().optional(),
    surname: z.string().optional(),
    fiscalCode: z.string().optional(),
});
const billingInfo = z.object({
    isCompany: z.boolean(),
    companyInfo: billingCompanyInfo.nullable().optional(),
    privateInfo: billingPrivateInfo.nullable().optional(),
    town: z.string(),
    city: z.string(),
    postcode: z.string(),
    address: z.string(),
    fax: z.string().optional(),
    phone: z.string().optional(),
    valid: z.boolean().optional(),
});

const billingCompanyInfoSchema = {
    companyName: 'company_name',
    vat: 'vat',
    taxCode: 'tax_code',
    companyRef: 'company_ref',
    pec: 'pec',
    sdi: 'sdi',
};
const billingPrivateInfoSchema = {
    invoice: 'invoice',
    name: 'name',
    surname: 'surname',
    fiscalCode: 'fiscal_code',
};
const billingInfoSchema = {
    isCompany: 'is_company',
    privateInfo: {
        path: 'private_info',
        fn: morphism(billingPrivateInfoSchema),
    },
    companyInfo: {
        path: 'company_info',
        fn: morphism(billingCompanyInfoSchema),
    },
    town: 'town',
    city: 'city',
    postcode: 'postcode',
    address: 'address',
    fax: 'fax',
    phone: 'phone',
    valid: 'valid',
};

const purchasePoOrder = (origin, entrypoint, order, sbtHeaders, timeoutMs, logger) => serverPost({
    url: `${origin}/v1/payments/purchase/${entrypoint.toLowerCase()}`,
    sbtHeaders,
    timeoutMs,
    logger,
}, order).then(processBody(purchasedPoOrderSchema, purchasedPoOrder));
const purchasePfOrder = (origin, entrypoint, order, sbtHeaders, timeoutMs, logger) => serverPost({
    url: `${origin}/v1/payments/purchase/premium_features/${entrypoint.toLowerCase()}`,
    sbtHeaders,
    timeoutMs,
    logger,
}, order).then(processBody(purchasedPoOrderSchema, purchasedPoOrder));
const getBillingInfo = (origin, userID, sbtHeaders) => serverGet({
    url: `${origin}/v1/users/${userID}/billing_info`,
    sbtHeaders,
}).then(processBody(billingInfoSchema, billingInfo));
const getPlutusPurchaseToken = (origin, sbtHeaders, logger) => serverGet({
    url: `${origin}/v1/payments/purchase_token`,
    sbtHeaders,
    logger,
}).then(processBody(plutusPurchaseTokenSchema, plutusPurchaseToken));

const getUserProfileInfo = (origin, userID, sbtHeaders, timeout, logger) => serverGet({
    url: `${origin}/v1/users/${userID}/info/profile/query`,
    sbtHeaders,
    timeoutMs: timeout,
    logger,
}).then(processBody(userProfileInfoSchema, userProfileInfo));

const trustProfileInfoSchema = createStrictSchema({
    reputation: 'reputation',
    identity: 'identity',
    communication: 'communication',
    presence: 'presence',
    badges: 'badges',
    links: '_links',
    replyTimeText: 'replyTimeText',
});

const trustPresenceStatus = z.enum(['OFFLINE', 'ONLINE']);
const trustCategoryScores = z.object({
    GENERAL: z.number().optional(),
    USER_ATTENTION: z.number().optional(),
});
const trustSourceScores = z.object({
    MEMBER: z.number().optional(),
    AUTOMATIC: z.number().optional(),
});
const trustSourceCounts = z.object({
    MEMBER: z.number().optional(),
    AUTOMATIC: z.number().optional(),
});
const trustFeedback = z.object({
    overallScore: z.number(),
    categoryScores: trustCategoryScores,
    receivedCount: z.number(),
    sourceScores: trustSourceScores,
    sourceCounts: trustSourceCounts,
});
const trustBadgeTipAction = z.object({
    text: z.string(),
    link: z.string(),
});
const trustBadgeTip = z.object({
    text: z.string(),
    action: z.nullable(trustBadgeTipAction),
});
const trustReputation = z.object({
    feedback: z.nullable(trustFeedback),
});
const trustIdentity = z.object({
    name: z.string().nullable(),
    avatar: z.string().nullable(),
    memberSince: z.string().nullable(),
    description: z.string().nullable(),
    localProfileId: z.string().nullable(),
    municipality: z.string().nullable(),
    region: z.string().nullable(),
    verified: z.boolean(),
});
const trustCommunication = z.object({
    replyTimeText: z.string().nullable(),
    replyTimeInMinutes: z.number().nullable(),
});
const trustPresence = z.object({
    status: z.nullable(trustPresenceStatus),
    presenceText: z.string().nullable(),
    lastActivity: z.string().nullable(),
    enabled: z.boolean(),
});
const trustBadge = z.object({
    id: z.string(),
    amount: z.number(),
    text: z.string(),
    tip: trustBadgeTip,
});
const trustProfileInfo = z.object({
    reputation: trustReputation,
    identity: trustIdentity,
    communication: trustCommunication,
    presence: trustPresence,
    badges: z.array(trustBadge),
    links: z.object({
        self: z.object({
            href: z.string(),
        }),
    }),
    replyTimeText: z.string().nullable(),
});

const getProfileTrustInfo = (origin, userID, sbtHeaders, timeout, logger) => serverGet({
    url: `${origin}/profile/sdrn:subito:user:${userID}`,
    sbtHeaders,
    timeoutMs: timeout,
    logger,
}).then(processBody(trustProfileInfoSchema, trustProfileInfo));

const getShopGoogleReviews = (origin, shopID, sbtHeaders) => serverGet({
    url: `${origin}/v1/shops/${shopID}/reviews`,
    sbtHeaders,
    acceptedErrorStatuses: [HTTPStatusCode.NotFound],
}).then(processBody(shopGoogleReviewsSchema, shopGoogleReviews));

const createPoOrder = (origin, order, sbtHeaders, logger) => serverPost({ url: `${origin}/carrello`, sbtHeaders, logger }, {
    order,
}).then(async (res) => {
    const result = await processBody(null, poCartRedirect)(res);
    const cookiesFromServer = res.headers.getSetCookie();
    const cartCookie = cookiesFromServer.find((entry) => entry.startsWith('cart_order='));
    const cartCookieKey = cartCookie?.split('=')?.[1] ?? '';
    return {
        ...result,
        body: {
            ...result.body,
            cartCookieKey,
        },
    };
});

export { changeEmailEligibility, createPoOrder, getActiveVoBanners, getBillingInfo, getConversationID, getFaq, getFavAdStatistics, getFee, getFees, getFilterValues, getHyperwalletAuthToken, getLatestVersion, getLoggedUser, getPayments, getPayoutUser, getPlutusPurchaseToken, getPrices, getPricesPreview, getProfileTrustInfo, getPromoInfo, getPublicationFee, getRates, getSellerCapabilities, getShop, getShopByUserId, getShopGoogleReviews, getSingleAd, getSingleVersion, getTransaction, getTransactionRates, getTransactionStates, getTransactions, getUserAdInfo, getUserAds, getUserProfileInfo, getUserSavedSearch, getUserSubscriptions, getUserTransactions, getUsers, getVisibilityOptions, getWalletType, prolongAd, purchasePfOrder, purchasePoOrder, searchGallerized, searchGeoboosted, searchItems, searchShops, verifyAdOwner };
//# sourceMappingURL=server_index.js.map
